var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web_Version",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nutzerdetailseite_2_edit-Copy-3",
    transform: "translate(-841.000000, -193.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Vorlader",
    transform: "translate(838.000000, 190.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5645161,3.22580645 L5.08064516,3.22580645 C4.41129032,3.22580645 3.87096774,3.82016129 3.87096774,4.55645161 L3.87096774,7.21774194 C3.87096774,7.79435484 4.20967742,8.28225806 4.67741935,8.46854839 L4.67741935,16.0887097 C4.67741935,16.825 5.21774194,17.4193548 5.88709677,17.4193548 L14.7580645,17.4193548 C15.4274194,17.4193548 15.9677419,16.825 15.9677419,16.0887097 L15.9677419,8.46854839 C16.4354839,8.28225806 16.7741935,7.79435484 16.7741935,7.21774194 L16.7741935,4.55645161 C16.7741935,3.82016129 16.233871,3.22580645 15.5645161,3.22580645 Z M15.6806998,7.21774194 L5.40185894,7.21774194 L5.40185894,4.55645161 L15.6806998,4.55645161 L15.6806998,7.21774194 Z M5.83925642,16.3104839 L5.83925642,8.5483871 L14.8059049,8.5483871 L14.8059049,16.3104839 L5.83925642,16.3104839 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxWhite);
export default __webpack_public_path__ + "static/media/box_white.122438181936714c7367122b77b27f1a.svg";
export { ForwardRef as ReactComponent };